export const FORTY_FIVE_DAYS_AGO = new Date(Date.now() - 45 * 24 * 60 * 60 * 1000); // 45th day from current day and time
export const CALENDAR_MAX_DATE = "2099-12-31";
export const JOB_CONFIGURATION_GET_COMMANDS = [
    { id: "get_cmnd_1", name: "Profile Capture Period", value: "PROFILE_CAPTURE_PERIOD" },
    { id: "set_cmnd_2", name: "Demand Integration Period", value: "DEMAND_INTEGRATION_PERIOD" },
    { id: "get_cmnd_3", name: "Billing Period and Billing Cycle", value: "BILLING_PERIOD" },
    { id: "get_cmnd_4", name: "Alarm Filter", value: "ALARM_FILTER" },
    { id: "get_cmnd_5", name: "Event Thresholds", value: "EVENT_THRESHOLD" },
    { id: "get_cmnd_6", name: "Time of Use (TOU)", value: "TARIFF_CALENDAR" },
    { id: "get_cmnd_7", name: "Load Curtailment", value: "LOAD_CURTAILMENT" },
    { id: "get_cmnd_8", name: "Payment Mode", value: "PAYMENT" },
    { id: "get_cmnd_9", name: "Metering Mode", value: "METERING_MODE" },
    { id: "get_cmnd_10", name: "Disconnector Control", value: "DISCONNECTOR_CONTROL" },
    { id: "get_cmnd_12", name: "kVAh Selection", value: "KVAH_SELECTION" },
    { id: "get_cmnd_13", name: "User Interface", value: "USER_INTERFACE" },
];
export const JOB_CONFIGURATION_SET_COMMANDS = [
    { id: "set_cmnd_1", name: "Profile Capture Period", value: "PROFILE_CAPTURE_PERIOD" },
    { id: "set_cmnd_2", name: "Demand Integration Period", value: "DEMAND_INTEGRATION_PERIOD" },
    { id: "set_cmnd_3", name: "Billing Period and Billing Cycle", value: "BILLING_PERIOD" },
    { id: "set_cmnd_4", name: "Alarm Filter", value: "ALARM_FILTER" },
    { id: "set_cmnd_5", name: "Event Thresholds", value: "EVENT_THRESHOLD" },
    { id: "set_cmnd_6", name: "Time of Use (TOU)", value: "TARIFF_CALENDAR" },
    { id: "set_cmnd_7", name: "Load Curtailment", value: "LOAD_CURTAILMENT" },
    { id: "set_cmnd_8", name: "Payment Mode", value: "PAYMENT" },
    { id: "set_cmnd_9", name: "Metering Mode", value: "METERING_MODE" },
    { id: "set_cmnd_10", name: "Disconnector Control", value: "DISCONNECTOR_CONTROL" },
    { id: "set_cmnd_12", name: "kVAh Selection", value: "KVAH_SELECTION" },
    { id: "set_cmnd_14", name: "MD Reset", value: "MAX_DEMAND_RESET" },
    { id: "set_cmnd_13", name: "User Interface", value: "USER_INTERFACE" },
];
